(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketingTrackerNew.Settings.DataImports",
                {
                    url: "/DataImports",
                    component: "dataimports",
                    PageTitle: "Data Imports | Marketing Tracker"//,
                    //requiredPermissions: "DataImports:Access",
                    //resolve: {}
                });
        }
    ]);

    app.component("dataimports",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Settings/DataImports/data-imports-template.html",
            controller: dataImportsCtrl
        });

    dataImportsCtrl.$inject = ["figToaster", "marketingTrackerActOnApi", "marketingTrackerDataImportApi", "$q", "moment"];
    function dataImportsCtrl(figToaster, marketingTrackerActOnApi, marketingTrackerDataImportApi, $q, moment) {

        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isLoading: {
                        types: false,
                        imports: false
                    }
                },
                allImports: [],
                dataConnectionId: {
                    ready: false,
                    value: ""
                },
                importTypes: [],
                upload: upload
            });

        function upload(type, file) {
            type.isUploading = true;

            var payload = new FormData();
            payload.append("importFile", file);

            var message = "", toastClass = "";
            marketingTrackerDataImportApi.upload(type.ImportType, payload)
                .then(function (response) {
                    marketingTrackerDataImportApi.getDataImport(response.Id)
                        .then(function (response) {
                            type.Imports.unshift(response);
                        });
                    message = type.Description + " has been imported.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    console.log("Error: ", error);
                    message = "There was a problem importing your " + type.Description + ". Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    type.isUploading = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        function _getDataConnectionId() {
            marketingTrackerDataImportApi.getDataConnectionId()
                .then(function (result) {
                    $ctrl.dataConnectionId.ready = true;
                    $ctrl.dataConnectionId.value = result;
                })
                .catch(function () {
                    console.log("There was an error retrieving DataConnectionId.");
                })
                .finally(function () {
                    _getTypes();
                });
        }

        function _getTypes() {
            var s3Properties = {
                Id: '',
                Key: '',
                Bucket: 'fig.marketingtrackerqa.dataimports'
            };
            marketingTrackerDataImportApi.getTypes()
                .then(function (response) {
                    _.forEach(response, function (importType) {
                        var importInstructions = [
                            { Description: 'Login in to Act-On' },
                            { Description: 'Click <span class="is-blue-dark">Reports</span> &gt; <span class="is-blue-dark">"Data Studio"</span>' },
                            { Description: 'Click <span class="is-blue-dark">"Destinations"</span> <br><em>If you already added the S3 bucket, skip ahead a few steps</em>'},
                            { Description: 'Click <span class="is-blue-dark">"Add"</span> and select "Amazon S3"' },
                            { Description: 'Enter <span class="is-blue-dark">"ActOn S3 Connection"</span> as the Name for the new destination' },
                            {
                                Description: 'With the new destination selected, enter the following information:<br> "Access Key ID": <span class="is-grey-dark">' +
                                    '[Contact FIG]' + '</span> <br> "Secret Access Key": <span class="is-grey-dark">' + 
                                    '[Contact FIG]' + '</span><br> "Bucket": <span class="is-grey-dark">' +
                                    s3Properties.Bucket + '</span>' },
                            { Description: 'Click <span class="is-blue-dark">"Test Connection"</span> and verify that the connection was successful' },
                            { Description: 'Next, on the sidenav menu, click <span class="is-blue-dark">"Exports"</span> &gt; <span class="is-blue-dark">"New Export"</span>' },
                            {
                                Description: 'For Step 1, copy the following into the Name field:<br /><span class="is-grey-dark">' +
                                    importType.ImportType + '</span>'
                            },
                            { Description: 'Choose which fields to export' },
                            { Description: 'Setup frequency for Automated Exports' },
                            { Description: 'For Delivery, set the "Destination" as the S3 bucket you created earlier' },
                            {
                                Description: 'In the "Sub folder" field, enter: <br /><span class="is-grey-dark">' +
                                    'acton' + '</span>'
                            },
                            {
                                Description: 'Copy the following filename for into the "File name" field:<br /><span class="is-grey-dark">' +
                                    $ctrl.dataConnectionId.value + '_' + importType.ImportTypeId + '_'  + '</span>'
                            },
                            { Description: 'Click <span class="is-blue-dark">"Append Date"</span> at the end of the "File name" field' },
                            { Description: 'Make sure the "Format" is set to <span class="is-grey-dark">CSV (Comma Separated Values)</span>' },
                            { Description: 'Click <span class="is-blue-dark">"Finish"</span> to complete the Automated Export' }
                        ];
                        switch (importType.ImportType) {
                            case "ActOnClientList":
                                importType.CardName = 'Clients';
                                importType.Icon = 'fig-account-suit';
                                importType.Imports = [];
                                importType.Instructions = importInstructions;
                                break;
                            case "ActOnProspectList":
                                importType.CardName = 'Prospects';
                                importType.Icon = 'fig-account';
                                importType.Imports = [];
                                importType.Instructions = importInstructions;
                                break;
                            case "ActOnFormLog":
                                importType.CardName = 'Online Web Forms';
                                importType.Icon = 'fig-clipboard';
                                importType.Imports = [];
                                importType.Instructions = importInstructions;
                                break;
                            case "ActOnEmailData":
                                importType.CardName = 'Emails';
                                importType.Icon = 'fig-email';
                                importType.Imports = [];
                                importType.Instructions = importInstructions;
                                break;
                            default:
                                break;
                        }
                    });
                    $ctrl.importTypes = response;
                })
                .catch(function () {
                    console.log("There was an error retrieving Data Import configuration information.");
                })
                .finally(function () {
                    _getImports();
                });
        }
        function _getImports() {
            marketingTrackerDataImportApi.getDataImports()
                .then(function (response) {
                    _.forEach(response, function (dataImport) {
                        switch (dataImport.ImportType) {
                            case "ActOnClientList":
                                $ctrl.importTypes[0].Imports = $ctrl.importTypes[0].Imports.concat(dataImport);
                                break;
                            case "ActOnProspectList":
                                $ctrl.importTypes[3].Imports = $ctrl.importTypes[3].Imports.concat(dataImport);
                                break;
                            case "ActOnFormLog":
                                $ctrl.importTypes[2].Imports = $ctrl.importTypes[2].Imports.concat(dataImport);
                                break;
                            case "ActOnEmailData":
                                $ctrl.importTypes[1].Imports = $ctrl.importTypes[1].Imports.concat(dataImport);
                                break;
                            default:
                                break;
                        }
                    });
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    var message = "There was a problem retrieving your data. Please try again shortly.";
                    var toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                });
        }

        $ctrl.$onInit = function () {
            var promises = [];
            $ctrl.ui.isLoading.type = true;

            promises.push(_getDataConnectionId());

            $q.all(promises)
                .finally(function () {
                    $ctrl.ui.isLoading.type = false;
                });
        };
    }

})(window.app, window.angular); // jshint ignore:line